<template>
  <div class="noOrder">
    <div class="header"></div>
    <div class="content">
      <input
        style="border-bottom: 2px solid #e5ebe9"
        v-model="contactsMobile"
        type="text"
        class="tel"
        placeholder="联系电话"
        maxlength="11"
      />
      <input
        style="border-bottom: 2px solid #e5ebe9"
        v-model="cardNo"
        type="text"
        class="idcard"
        placeholder="入网人身份证号"
        maxlength="18"
      />
    </div>
    <div class="tips" v-if="showResult">
      <p style="color: #000">查询结果：</p>
      <p>{{ Tiptext }}</p>
    </div>
    <div>
      <van-button
        type="primary"
        class="Btn"
        size="large"
        color="#5cc8d5"
        @click="checkOrder"
      >
        立即查询
      </van-button>
    </div>
  </div>
</template>

<script>
import { Button } from "vant";
import { http } from "@/api/http";
export default {
  name: "noOrder",
  data() {
    return {
      contactsMobile: "",
      cardNo: "",
      Tiptext: "",
      showResult: false,
    };
  },
  components: {
    vanButton: Button,
  },
  methods: {
    async checkOrder() {
      let params = {
        contactsMobile: this.contactsMobile,
        cardNo: this.cardNo,
        spiDepartId: this.$route.query.spiId,
      };
      const { result } = await http("checkOrderExist", params);
      this.showResult = true;
      if (result.hasOrder) {
        this.Tiptext = "您的骑士卡申请订单已经提交，请耐心待工作人员处理";
      } else {
        this.Tiptext = "未查询到订单，请确认联系电话或身份证是否有误";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.noOrder {
  width: 100%;
  height: 100%;
  font-size: 0.8rem !important;
  .header {
    height: 3.5rem;
    background: linear-gradient(to right, #65d1c2, #65d1c2, #5cc8d5);
  }
  .content {
    input {
      outline: none;
      border: 0px;
      text-indent: 3rem;
      width: 100%;
      height: 3rem;
      border-bottom: 0.018519rem solid #e5ebe9;
      font-size: 0.8rem;
    }
    input:nth-child(1) {
      background: url(../assets/phone.png) 1rem center no-repeat #fff;
      background-size: 1rem;
    }
    input:nth-child(2) {
      background: url(../assets/idCard.png) 1rem center no-repeat #fff;
      background-size: 1rem;
    }
  }
  .tips {
    font-size: 0.8rem;
    color: #5cc8d5;
    text-align: left;
    margin: 3rem;
    white-space: pre-wrap;
  }
  .Btn {
    position: fixed;
    left: 0;
    bottom: 0;
  }
}
</style>
